import React, { useEffect, useState } from 'react';
import { GridRowsProp, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IEmailNotification from '../../interfaces/IEmailNotification';
import CAppDataGrid from '../../../../app/components/CAppDataGrid';
import AppFormatDate from '../../../../app/features/format/AppFormatDate';
import langAdminDocumentEmailNotifications from '../../langs/langAdminDocumentEmailNotifications';
import alasql from 'alasql';

type CAdminDocumentEmailNotificationTableProps = {
	emailNotifications: IEmailNotification[];
};
const CAdminDocumentEmailNotificationTable = (props: CAdminDocumentEmailNotificationTableProps) => {
	const { emailNotifications } = props;

	const { t } = useTranslation();

	const [rows, setRows] = useState<GridRowsProp>();

	useEffect(() => {
		if (emailNotifications) {
			const data = emailNotifications.map((x) => ({
				fundId: x.fund?.id,
				fundName: x.fund?.name,
				documentId: x.document?.id,
				documentName: x.document?.name,
				documentReleaseDate: x.documentReleaseDate,
				userId: x.user?.id,
				statusTag: x.notification?.statusTag,
			}));
			const res = alasql(
				`SELECT *, 
				COUNT(IIF(statusTag === 'planned', userId, null)) AS nbUserEmailToSend,
				COUNT(IIF(statusTag === 'pending', userId, null)) AS nbUserEmailInProgress, 
				COUNT(IIF(statusTag === 'sent', userId, null)) AS nbUserEmailSent, 
				COUNT(IIF(statusTag === 'bounced', userId, null)) AS nbUserEmailBounced, 
				COUNT(IIF(statusTag === 'error', userId, null)) AS nbUserEmailError, 
				COUNT(IIF(statusTag === 'undefined', userId, null)) AS nbUserEmailUndefined, 
				COUNT(DISTINCT userId) AS nbUserEmail 
				FROM ? GROUP BY fundId,documentId`,
				[data],
			);
			setRows(
				res.map((x: Record<string, unknown>, index: number) => ({
					...x,
					id: index,
				})),
			);
		}
	}, [emailNotifications]);

	const columns: GridColDef[] = [
		{
			field: 'fundName',
			headerName: t(langAdminDocumentEmailNotifications.column_fund_name.tag),
			minWidth: 200,
			flex: 1,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'documentName',
			headerName: t(langAdminDocumentEmailNotifications.column_document_name.tag),
			width: 200,
			flex: 1,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'documentReleaseDate',
			headerName: t(langAdminDocumentEmailNotifications.column_document_release_date.tag),
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params: GridRenderCellParams) => <AppFormatDate date={params.value} />,
		},
		{
			field: 'nbUserEmail',
			headerName: t(langAdminDocumentEmailNotifications.column_nb_user_email.tag),
			width: 80,
			align: 'right',
			headerAlign: 'right',
		},
		{
			field: 'nbUserEmailToSend',
			headerName: t(langAdminDocumentEmailNotifications.column_nb_user_email_to_send.tag),
			width: 80,
			align: 'right',
			headerAlign: 'right',
		},
		{
			field: 'nbUserEmailInProgress',
			headerName: t(langAdminDocumentEmailNotifications.column_nb_user_email_in_progress.tag),
			width: 80,
			align: 'right',
			headerAlign: 'right',
		},
		{
			field: 'nbUserEmailSent',
			headerName: t(langAdminDocumentEmailNotifications.column_nb_user_email_sent.tag),
			width: 80,
			align: 'right',
			headerAlign: 'right',
		},
		{
			field: 'nbUserEmailBounced',
			headerName: t(langAdminDocumentEmailNotifications.column_nb_user_email_bounced.tag),
			width: 80,
			align: 'right',
			headerAlign: 'right',
		},
		{
			field: 'nbUserEmailError',
			headerName: t(langAdminDocumentEmailNotifications.column_nb_user_email_error.tag),
			width: 80,
			align: 'right',
			headerAlign: 'right',
		},
		{
			field: 'nbUserEmailUndefined',
			headerName: t(langAdminDocumentEmailNotifications.column_nb_user_email_undefined.tag),
			width: 80,
			align: 'right',
			headerAlign: 'right',
		},
	];

	return (
		<>
			{rows ? (
				<Box>
					<CAppDataGrid
						className="admin-email-notifications-table"
						rows={rows}
						columns={columns}
						autoHeight
						pagination
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default CAdminDocumentEmailNotificationTable;
